import React from 'react';
import { AdvertisementDto } from '../interface/device.details';
import { isVideoFile } from '../utils/common.utils';
import { ADS_URL } from '../utils/env-utils';
import { AdvertisementType } from '@industronics/fids-utils';

interface AdvertisementDisplayProps {
  advertisement: AdvertisementDto | null;
  isFullScreen?: boolean;
}

const AdvertisementDisplay: React.FC<AdvertisementDisplayProps> = ({
  advertisement,
  isFullScreen = false
}) => {
  if (!advertisement || advertisement.type !== "ad") {
    return null;
  }

  const isFullScreenAd = !advertisement.ratio &&
    advertisement.advertisementType === AdvertisementType.FullScreen;

  if (isFullScreen && isFullScreenAd) {
    return isVideoFile(advertisement.file) ? (
      <div className="position-fixed top-0 start-0 w-100 h-100 overflow-hidden m-0 p-0">
        <video
          src={`${ADS_URL}${advertisement.file}`}
          autoPlay
          muted
          loop
          playsInline
          className="w-100 h-100"
          style={{ objectFit: 'cover' }}
        />
      </div>
    ) : (
      <img
        style={{ height: "100vh", width: "100%" }}
        src={`${ADS_URL}${advertisement.file}`}
        alt={`Ad ${advertisement.id}`}
      />
    );
  }

  if (!isFullScreen && advertisement.ratio) {
    return (
      <div
        style={{
          textAlign: "center",
          fontWeight: "bold",
          marginTop: "0.5rem",
          color: "white"
        }}
      >
        {isVideoFile(advertisement.file) ? (
          <div>
            <video
              src={`${ADS_URL}${advertisement.file}`}
              autoPlay
              muted
              loop
              playsInline
              className="w-100 h-100"
              style={{ objectFit: 'cover' }}
            />
          </div>
        ) : (
          <img
            style={{ height: "100vh", width: "100%" }}
            src={`${ADS_URL}${advertisement.file}`}
            alt={`Ad ${advertisement.id}`}
          />
        )}
      </div>
    );
  }

  return null;
};

export default AdvertisementDisplay;